export const DEFAULT_AVATAR_URL = 'https://ui-avatars.com/api/?name=User&background=E5E7EB&color=6B7280&size=256&rounded=true&bold=true';